import { filter, set } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import axios from 'axios';
// components
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../components/SearchNotFound';
import { PgdpmListHead, PgdpmListToolbar, PgdpmMoreMenu } from '../sections/reports';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'pgdpmtitle', label: 'PGDPMTitle', alignRight: false },
  { id: 'pgdpmdescription', label: 'PGDPMDescription', alignRight: false },
  { id: 'title', label: 'Title', alignRight: false },
  { id: 'year', label: 'Year', alignRight: false },
  { id: 'material', label: 'DMaterial', alignRight: false },
  { id: 'active', label: 'Active', alignRight: false },
  { id: 'action', label: 'Action', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query, roleFilter) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  let filteredArray = stabilizedThis.map((el) => el[0]);

  // Apply text query filter
  if (query) {
    filteredArray = filteredArray.filter((pgdpm) => {
      if (pgdpm.title.toLowerCase().includes(query.toLowerCase())) {
        return true;
      }
      if (String(pgdpm.year).toLowerCase().includes(query.toLowerCase())) {
        return true;
      }
      if (pgdpm.material.toLowerCase().includes(query.toLowerCase())) {
        return true;
      }
      if (pgdpm.active.toLowerCase().includes(query.toLowerCase())) {
        return true;
      }

      return false;
    });
  }


  return filteredArray;
}

export default function Dqm() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('desc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('year'); // Default sort by email
  const [filterName, setFilterName] = useState('');
  const [roleFilter, setRoleFilter] = useState(''); // State for role filter
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // State for pgdpm
  const [pgdpm, setPgdpm] = useState([]);
  const [editingpgdpmId, setEditingPgdpmId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [title, setTitle] = useState('');
  const [year, setYear] = useState('');
  const [material, setMaterial] = useState('');
  const [active, setActive] = useState('');
  const [selectedpgdpm, setSelectedPgdpm] = useState(null);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [pgdpmtitle, setPgdpmTitle] = useState('');
  const [pgdpmdescription, setPgdpmDescription] = useState('');




  // Fetch pgdpm from the server on component mount
  useEffect(() => {
    fetchpgdpm();
  }, []);

  // Fetch pgdpm from the server
  const fetchpgdpm = async () => {
    try {
      const response = await axios.get('https://cpccbe.org/api/pgdpms/getallpgdpms');
      setPgdpm(response.data);
    } catch (error) {
      console.error("Error fetching pgdpm:", error);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = pgdpm.map((n) => n.email); // Use email as unique identifier
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, email) => {
    const selectedIndex = selected.indexOf(email);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, email);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  // Handle opening and closing of modal for editing pgdpm
  const handleOpenModal = (pgdpmId) => {
    if (pgdpmId) {

      const pgdpmtoEdit = pgdpm.find(pgdpm => pgdpm._id === pgdpmId);
      if (pgdpmtoEdit) {
        setPgdpmTitle(pgdpmtoEdit.pgdpmtitle);
        setPgdpmDescription(pgdpmtoEdit.pgdpmdescription);
        setTitle(pgdpmtoEdit.title);
        setYear(pgdpmtoEdit.year);
        setMaterial(pgdpmtoEdit.material);
        setActive(pgdpmtoEdit.active);
        setEditingPgdpmId(pgdpmId);

      }
    } else {
      setPgdpmTitle('');
      setPgdpmDescription('');
      setTitle('');
      setYear('');
      setMaterial('')
      setActive('');
      setEditingPgdpmId(null);
    }
    setOpenModal(true);

  };


  const handleCloseModal = () => {
    setOpenModal(false);
    setPgdpmTitle('');
    setPgdpmDescription('');
    setTitle('');
    setYear('');
    setMaterial('')
    setActive('');
    setEditingPgdpmId(null);

  };



  // Handle adding a new pgdpm
  const handleAddpgdpm = async () => {
    try {
      const response = await axios.post('https://cpccbe.org/api/pgdpms/createpgdpms', { pgdpmtitle, pgdpmdescription, title, year, material, active }); // Adjust based on your actual data structure

      fetchpgdpm(); // Refresh pgdpm list after adding
      handleCloseModal(); // Close modal after adding
    } catch (error) {
      console.error("Error adding pgdpm:", error);
    }
  };

  // Handle updating a pgdpm
  const handleUpdatepgdpm = async () => {
    try {
      await axios.patch(`https://cpccbe.org/api/pgdpms/updatepgdpms/${editingpgdpmId}`, { pgdpmtitle, pgdpmdescription, title, year, material, active }); // Adjust endpoint as necessary
      fetchpgdpm(); // Refresh pgdpm list after updating
      handleCloseModal(); // Close modal after updating
    } catch (error) {
      console.error("Error updating pgdpm:", error);
    }
  };

  // Handle deleting a pgdpm
  const handleDeletepgdpm = async (pgdpmId) => {
    if (window.confirm("Are you sure you want to delete this pgdpm?")) {
      try {
        await axios.delete(`https://cpccbe.org/api/pgdpms/deletepgdpms/${pgdpmId}`); // Adjust endpoint as necessary
        fetchpgdpm(); // Refresh pgdpm list after deletion
      } catch (error) {
        console.error("Error deleting pgdpm:", error);
      }
    }
  };

  const handleViewpgdpm = (pgdpm) => {
    // Open a modal or set state to display dqm details
    setSelectedPgdpm(pgdpm); // Assuming you have state to hold selected history data
    setViewModalOpen(true); // Open the modal for viewing history details
  };




  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - pgdpm.length) : 0;

  // Apply sorting and filtering
  const filteredpgdpm = applySortFilter(pgdpm, getComparator(order, orderBy), filterName, roleFilter);


  const ispgdpmNotFound = filteredpgdpm.length === 0;

  return (
    <Page title="pgdpm">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            PGDPM
          </Typography>
          <Button variant="contained" onClick={handleOpenModal} startIcon={<Iconify icon="eva:plus-fill" />}>
            New PGDPM
          </Button>
        </Stack>

        <Card>
          <PgdpmListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            roleFilter={roleFilter}
            onRoleFilterChange={(e) => setRoleFilter(e.target.value)}
          />


          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <PgdpmListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={pgdpm.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredpgdpm.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { _id, email, role } = row; // Adjust based on your actual data structure
                    const isItemSelected = selected.indexOf(email) !== -1;

                    return (
                      <TableRow
                        hover
                        key={_id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell align="left">
                          <IconButton onClick={() => handleViewpgdpm(row)} aria-label="view pgdpm">
                            <Iconify icon="eva:eye-fill" />
                          </IconButton>
                        </TableCell>
                        <TableCell align="left">{row.pgdpmtitle}</TableCell>
                        <TableCell align="left">{row.pgdpmdescription}</TableCell>
                        <TableCell align="left">{row.title}</TableCell>
                        <TableCell align="left">{row.year}</TableCell>
                        <TableCell align="left">{row.material}</TableCell>
                        <TableCell align="left">{row.active}</TableCell>
                        <TableCell align="left">
                          <PgdpmMoreMenu
                            onEdit={() => handleOpenModal(row._id)}
                            onDelete={() => handleDeletepgdpm(row._id)}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {ispgdpmNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={pgdpm.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>

        {/* Modal for Editing pgdpm */}
        <Dialog open={openModal} onClose={handleCloseModal}>
          <DialogTitle>{editingpgdpmId ? "Edit pgdpm" : "Add New pgdpm"}</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="pgdpmtitle"
              label="PGDPM Title"
              type="text"
              fullWidth
              value={pgdpmtitle}
              onChange={(e) => setPgdpmTitle(e.target.value)}
            />

            <TextField
              margin="dense"
              id="pgdpmdescription"
              label="PGDPM Description"
              type="text"
              fullWidth
              value={pgdpmdescription}
              onChange={(e) => setPgdpmDescription(e.target.value)}
            />

            <TextField
              autoFocus
              margin="dense"
              id="title"
              label="Title"
              type="text"
              fullWidth
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <TextField
              margin="dense"
              id="year"
              label="Year"
              type="text"
              fullWidth
              value={year}
              onChange={(e) => setYear(e.target.value)}
            />
            <TextField
              margin="dense"
              id="material"
              label="Material"
              type="text"
              fullWidth
              value={material}
              onChange={(e) => setMaterial(e.target.value)}
            />
            <FormControl fullWidth margin='dense'>
              <InputLabel id="active">Active</InputLabel>
              <Select
                labelId="active"
                id="active"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="inactive">Inactive</MenuItem>
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal}>Cancel</Button>
            {editingpgdpmId ? (
              <Button onClick={handleUpdatepgdpm}>Update PGDPM</Button>
            ) : (
              <Button onClick={handleAddpgdpm}>Add PGDPM</Button>
            )}
          </DialogActions>
        </Dialog>

        <Dialog open={viewModalOpen} onClose={() => setViewModalOpen(false)}>
          <DialogTitle>PGDPM Details</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="pgdpmtitle"
              label="PGDPM Title"
              type="text"
              fullWidth
              value={selectedpgdpm?.pgdpmtitle}
              disabled
            />
            <TextField
              margin="dense"
              id="pgdpmdescription"
              label="PGDPM Description"
              type="text"
              fullWidth
              value={selectedpgdpm?.pgdpmdescription}
              disabled
            />
            <TextField
              margin="dense"
              id="title"
              label="Title"
              type="text"
              fullWidth
              value={selectedpgdpm?.title}
              disabled
            />
            <TextField
              margin="dense"
              id="year"
              label="Year"
              type="text"
              fullWidth
              value={selectedpgdpm?.year}
              disabled
            />
            <TextField
              margin="dense"
              id="material"
              label="Material"
              type="text"
              fullWidth
              value={selectedpgdpm?.material}
              disabled
            />
            <TextField
              margin="dense"
              id="active"
              label="Active"
              type="text"
              fullWidth
              value={selectedpgdpm?.active}
              disabled
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setViewModalOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>


      </Container>
    </Page>
  );
}
